var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"d-flex align-items-center mb-2"},[_c('b-col',[_c('div',{staticClass:"d-flex align-items-center ml-3"},[_c('b-breadcrumb',{staticClass:"bg-transparent mb-0 mt-1",attrs:{"items":_vm.page.breadCrumb}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }